// import { faChartBar as metricsIcon } from '@fortawesome/free-solid-svg-icons'
import { faSitemap as relationshipsIcon } from '@fortawesome/free-solid-svg-icons'
// import { faCalendarAlt as reservationsIcon } from '@fortawesome/free-solid-svg-icons'
// import { faCog as configIcon } from '@fortawesome/free-solid-svg-icons'
import { faStar as starIcon } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle as helpIcon } from '@fortawesome/free-solid-svg-icons';
import { faHome as homeIcon } from '@fortawesome/free-solid-svg-icons'
import { faMapPin as localSEO } from '@fortawesome/free-solid-svg-icons' 
import { faFilter as segmentsIcon } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope as campaignsIcon } from '@fortawesome/free-solid-svg-icons';

import { Feature } from '../commons/enums/Feature.js';
import { envConfig } from './config.js';

export const comparePaths = (pathWithParams, realPath) => {
	let pathWithParamsSplitted = pathWithParams.split('/');
	let realPathSplitted = realPath.split('/');

	let areEqual = (pathWithParamsSplitted.length === realPathSplitted.length);

	if (areEqual) {
		pathWithParamsSplitted.forEach((element, index) => {
			if (element.indexOf(':') === -1 && element !== realPathSplitted[index]) {
				areEqual = false;
			}
		});
	}
	return areEqual;
}

export const getPageTitleParams = (url) => {
	var path = ["Home"];
	var title;
	var showPageTitle = true;
	var notVisible = false;
	let menuConf = menuConfig();


	for (const item of menuConf.menu) {
		for (const subitem of item.children) {
			if (comparePaths(subitem.url, url)) {
				path.push("menu." + item.text + ".text");
				path.push("menu." + subitem.text + ".text");
				title = "menu." + subitem.text + ".title";
				if (subitem.showPageTitle !== undefined && subitem.showPageTitle === false) showPageTitle = false;
				if (subitem.notVisible) notVisible = true;
			}
		}

	}

	return {
		title: title,
		path: path,
		showPageTitle: showPageTitle,
		notVisible: notVisible,
	}
}

export const getMenuFromLocation = (location) => {
	let menuConf = menuConfig();

	for (const item of menuConf.menu) {
		for (const subitem of item.children) {
			if (subitem.url === location) {
				return subitem;
			}
		}

	}
}

const getV2DashboardUrl = () => {
	if (envConfig.v2LoginUrl) {
	  return envConfig.v2LoginUrl + '?returnUrl=' + encodeURIComponent('/dashboard');
	}
	return "/dashboard";
  };

const getV2SentimentUrl = () => {
	if (envConfig.v2LoginUrl) {
	  return envConfig.v2LoginUrl + '?returnUrl=' + encodeURIComponent('/dashboard/sentiment-analysis');
	}
	return "/sentiment";
  };
	

export const menuConfig = (selectedCompany = { id: undefined }, admin = { operations: []}) => {
	return {
		menu: [
			{
				key: "metrics_control_panel",
				text: 'home',
				// icon: metricsIcon,
				icon: homeIcon,
				// url: "/dashboard",
				url: getV2DashboardUrl(),
				target: "_self", 
				operations: "STORE_ANALYTICS__VIEW",
				noChildrenMenu: true,
				children: [
					{
						showPageTitle: false,
						key: "metrics_control_panel",
						text: 'controlPanel',
						operations: "STORE_ANALYTICS__VIEW",
						// url: "/dashboard"
						url: getV2DashboardUrl(),
					},
				]
			},
			{
				key: "localSEO",
				text: 'localSEO',
				icon: localSEO,
				children: [
					{
						key: "gbp_audit",
						text: 'gbpAudit',
						url: "/localseo/gbp",
						operations: "GBP__VIEW",
					},
					{
						key: "localPost",
						text: 'localPost',
						url: "/localseo/posts",
						operations: "SOCIAL_LOCATION_POST__EXECUTE",
					},
				]
			},
			{
				key: "feedback",
				text: 'feedback',
				icon: starIcon,
				planOperations: ["REVIEWS__VIEW"],
				feature: Feature.REVIEWS_AUTO_REPLY,
				notVisible: !selectedCompany.operations || !selectedCompany.operations.includes("REVIEWS__VIEW"),
				children: [
					{
						key: "feedback_reviews",
						text: 'reviews',
						url: "/feedback/reviews",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						showPageTitle: false
					},
					{
						key: "feedback_reviews",
						text: 'reviews',
						url: "/feedback/reviews/:id",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						showPageTitle: false,
						notVisible: true
					},
					{
						key: "feedback_metrics",
						text: 'feedbackMetrics',
						url: "/feedback/metrics",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						showPageTitle: false
					},
					{
						text: 'connectedStores',
						url: "/feedback/connectedstores",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						notVisible: true,
						showPageTitle: false
					},
					{
						key: "feedback_nps",
						text: 'nps',
						url: "/feedback/nps",
						product: 'feedback',
						showPageTitle: false,
						planOperations: ["REVIEWS_NPS__VIEW"],
						feature: Feature.NPS_DASHBOARD
					},
					{
						key: "feedback_replytemplates",
						text: 'replyTemplates',
						url: "/feedback/replytemplates",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						notVisible: true,
						showPageTitle: false
					},
					{
						key: "feedback_autoreplyrules",
						text: 'autoreplyrules',
						url: "/feedback/autoreplyrules",
						planOperations: ["REVIEWS__VIEW"],
						product: 'feedback',
						notVisible: true,
						showPageTitle: false
					},
					{
						text: 'socialaccounts',
						url: "/socialaccounts",
						operations: "STORES__EDIT",
						notVisible: true,
						showPageTitle: false
					},
					{
						text: 'widget',
						url: "/feedback/widget",
						operations: "REVIEWS_WIDGET__VIEW",
						product: 'feedback',
						notVisible: true,
						showPageTitle: false,
						planOperations: ["REVIEWS_WIDGET__VIEW"],
						feature: Feature.REVIEWS_WIDGET
					},
					{
						key: "feedback_survey",
						text: 'surveyStats',
						url: "/feedback/survey",
						operations: "REVIEWS__VIEW",
						product: 'feedback',
						showPageTitle: false,
						notVisible: !selectedCompany.npsCustomQuestions || selectedCompany.npsCustomQuestions.length === 0
					},
					{
						key: "review_leaderboard",
						text: 'leaderboard',
						url: "/review-leaderboard",
						noChildrenMenu: true,
						showPageTitle: false,
						planOperations: ["QRSCAN__VIEW"],
					}
				]
			},
			{
				key: "feedback_sentiment",
				text: 'sentiments',
				url: getV2SentimentUrl(),
				target: "_self",
				noChildrenMenu: true,
				icon: "heart",
				notVisible: !selectedCompany.operations || !selectedCompany.operations.includes("SENTIMENT_ANALYSIS__VIEW"),
				children: [{
					showPageTitle: false,
					key: "feedback_sentiment",
					text: 'sentiments',
					url: getV2SentimentUrl(),
					operations: null,
				}]
			},
			{
				key: "clients",
				text: "clients",
				icon: 'users',
				url: '/download-users',
				noChildrenMenu: false,
				children: [
					{
						key: "relationships_customers",
						text: 'downloadUsers',
						url: "/download-users",
						product: 'marketing',
						operations: "USERS__VIEW",
						showPageTitle: false
					},
					{
						key: "relationships_customers_old_crm",
						dontTrackEvent: true,
						text: 'clients',
						url: "/crm",
						product: 'marketing',
						operations: "USERS__VIEW",
						showPageTitle: false,
						notVisible: !selectedCompany || selectedCompany.id!==66
					}
				]
			},
			{
				key: "relationships",
				text: 'realationships',
				icon: relationshipsIcon,
				showOnlyIfHasSubscriptionStores: true,
				children: [
					{
						key: "relationships_tasks",
						text: 'tasks',
						url: "/tasks",
						operations: "USERS__VIEW",
						showOnlyIfHasSubscriptionStores: true,
						showPageTitle: false
					}
				]
			},
			{
				key: "help",
				text: 'help',
				icon: helpIcon,
				children: [
					{
						key: "help_helpCenter",
						text: 'helpCenter',
						url: "https://help.rayapp.io/es/",
						showPageTitle: false,
						target: "_blank",
						norel: "noopener noreferrer"
					},
					{
						key: "help_chat",
						text: 'chat',
						url: "#",
						showPageTitle: false,
						operations: "ALL",
						id: "intercomChat"
					},
				]
			},
			...(selectedCompany && selectedCompany.id === 1133 ? [{
				key: "campaigns",
				text: "campaigns",
				url: "/campaigns",
				icon: campaignsIcon,
				noChildrenMenu: true,
				showPageTitle: false,
				children: [
					{
						key: "campaigns_list",
						text: "campaigns",
						url: "/campaigns",
					}
				]
			}, {
				key: "segments",
				text: "segments",
				url: "/segments",
				icon: segmentsIcon,
				noChildrenMenu: true,
				showPageTitle: false,
				children: [
					{
						key: "segments_list",
						text: "segments",
						url: "/segments",
					}
				]
			}] : [])
		]
	}
};
